<template>
     
    <header class="header" :class="{ 'is-scrolled': isScrolled }" role="banner" >
        <div class="logo">
            <div  class="hp-logo animate__animated animate__rotateInDownLeft">
                
               <div :class="{ 'hp-only': isHome }">
    <NuxtLink to="/">
        <h1 v-if="isHome" class="sr-only">Pauline Fuchs - page d'accueil</h1>
        <img src="/logo.svg" alt="Logo de Pauline Fuchs">
    </NuxtLink>
</div>
            
            </div>
        </div>

        <nav class="navbar animate__animated  animate__zoomInRight" role="navigation"   aria-label="Menu principal">
            <NuxtLink to="/" v-if="!isHome" class="navbar__flower no-home" title="Retour à l'accueil">
                <span>Retour à l'accueil</span>
                <img src="/flower.svg">
            </NuxtLink>
            <div class="navbar__flower scroll-top " v-else>
                <img src="/flower.svg" @click="scrollToTop">
            </div>
            <button role="button" v-if="isMobile" class="toggle-menu" :class="{'is-active':isActive}" @click="toggleMenu">Menu  </button>
             <ul :class="{'mobile': isMobile,'is-active':isActive}">
                <li v-if="isMobile && !isHome"><NuxtLink to="/">Accueil</NuxtLink></li>
                <li><NuxtLink to="/projets">Projets</NuxtLink></li>
                <li><NuxtLink to="/a-propos" title="A propos de moi">A propos</NuxtLink></li>
                <li><NuxtLink to="/contact" title="Me contacter">Contact</NuxtLink></li>
            </ul>
        </nav>
</header>
</template>

<script lang="ts" setup>
//@ts-ignore
const viewport = useViewport() 

const route = useRoute()
const isHome = computed(() => route.fullPath === '/')
const isMobile = computed(() => viewport.isLessOrEquals('mobileWide'))
const isActive = ref(false)
const isScrolled = ref(false)

const toggleMenu = () => {
    isActive.value = !isActive.value
    document.querySelector('body')?.classList.toggle('overflow-hidden')
}

const closeMenu = () => {
  if (isActive.value) {
    isActive.value = false
    document.querySelector('body')?.classList.remove('overflow-hidden')
  }
}

const handleScroll = () => {
    isScrolled.value = window.scrollY > 50 
}

watch(() => route.fullPath, () => {
  closeMenu()
})

onMounted(() => {
    window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
})

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

</script> 

<style lang="scss">
    .header{
        display: flex;  
        justify-content: space-between;
        padding:     0 40px;
        height: 100px;
        position: relative;
        z-index: 40;
        position: fixed;
        top:0;
        left: 0;
        width: 100%; 
        background-color: $white;
        &.is-scrolled{
                box-shadow: rgba(27, 27, 27, 0.1) 0px 15px 40px 0px;    
        }
        @media screen and (max-width:1035px){
            padding: 20px 20px 0 20px;
        }
        @media screen and (max-width:1035px){
            padding: 20px;
        }
   
        .hp-logo,.hp-only{
            height: 100%;
        }
        .hp-only{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .logo{
            img{
                width: 200px;
                height:90px;
                @media screen and (max-width:1035px){
                    width: 150px;
                }
                @media screen and (max-width:550px){
                    width: 100px;
                    height: 70px;
                }
            }
        }
        .navbar{
            display: flex;
            align-items: center;
            gap: 10px;
            &__flower{
                background-color: transparent;
                border: none;
                cursor: pointer;
                width: 60px;
                height: 60px;
                padding: 0;
                transition: all 1s ease;
                    width: fit-content;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    text-decoration: none;
                    position: relative;
                        &:hover,&:focus{
                        img{
                     transform: rotate(360deg);
                   }
                        @media screen and (min-width: 760px){
                            span{
                            opacity: 1;
                            transform: translateY(0);
                            visibility: visible;
                        }
                        }
                    }
                    span{
                        color: #9152F7;
                        font-weight: 500;
                        display: block;
                        transition: all .2s;
                        left: -140px;
                        opacity: 0;
                        text-decoration: none;
                        position: absolute;
                        width:150px;
                        visibility: hidden;
                    }
                img{
                    transition: all 1s ease;
                    width: 60px;
                    height: 60px;
                }
            }
            .toggle-menu{
                color:white;
                background-color: $violet;
                padding: 10px 20px 10px 40px ;
                border:2px solid $violet;
                border-radius:30px;
                background-image: url('~/assets/svgs/burger.svg');
                background-repeat: no-repeat;
                background-position: center left 10px ;
                background-size: 20px;
                &.is-active{
                background-image: url('~/assets/svgs/close.svg');

                }
            }
            ul {
                margin: 0;
                 background-color: #9152F7;
                padding: 20px 40px ;
                border-radius: 50px;
                height: fit-content;
                display: flex;
                align-items: center;
                justify-content: center;
                list-style-type: none;
                gap: 40px;
                &.mobile{
                    display: none;
                }
                &.is-active{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    gap:0;
                    position: fixed;
                    top: 90px;
                    right: -20px;
                    width: 100vw;
                    border-radius: 0;
                    border-bottom-left-radius: 5px;
                    border-bottom-right-radius: 5px;
                    height: calc(100vh - 110px);
                    background-color: rgba(0,0,0,0.4);
                    padding: 0;

                    li{
                        background-color: $violet;
                        padding: 20px 30px 20px 20px;
                        text-align: right;
                        width: 100%;
                    }
                }
                li {
                   a {
                     color: white;
                     font-size: 20px;
                     text-decoration: none;
                     position: relative;
                     transition: all .4s;
                    display: block;
                    @media screen and (min-width:1035px){
                        &:hover{
                            transform: translateY(-5px);
                        }
                    }
                    @media screen and (max-width:1035px) {
                        font-size: 16px;
                    }
                    
                   
                   }
                }
            }
        }
    }
</style>